export class ParamsPayment {
    dt_inicial: string;
    dt_final: string;
}